// dashboard/components/Topbar.jsx
import { Box, InputBase, Avatar, Typography, IconButton, Badge } from '@mui/material';
import { Search, Notifications, Settings } from '@mui/icons-material';
import { useAuth } from '../../context/authContext';

const Topbar = ({ user, isMobile, toggleSidebar }) => {
  const { isAuthenticated } = useAuth();

  const getUserInitials = () => {
    if (!user) return 'U';
    if (user.first_name && user.last_name) {
      return `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase();
    }
    if (user.first_name) return user.first_name.charAt(0).toUpperCase();
    return 'U';
  };

  // Get the user's full name
  const getFullName = () => {
    if (!user) return 'User';
    if (user.first_name && user.last_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    if (user.first_name) return user.first_name;
    return 'User';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 2, sm: 3 },
        py: 2,
        bgcolor: '#ffffff',
        borderBottom: '1px solid #eef2f7',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      {/* Left side - Search */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          bgcolor: '#f8f9fa',
          px: 2,
          borderRadius: 2,
          width: { xs: '100%', sm: '400px' },
          height: 40,
        }}
      >
        <Search sx={{ color: '#8a8a9a', fontSize: 20 }} />
        <InputBase
          placeholder="Search..."
          sx={{ ml: 1, flex: 1, fontSize: '0.875rem' }}
        />
      </Box>

      {/* Right side - Actions */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton sx={{ color: '#6b7280' }}>
          <Badge badgeContent={3} color="error">
            <Notifications />
          </Badge>
        </IconButton>
        <IconButton sx={{ color: '#6b7280' }}>
          <Settings />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, ml: 1 }}>
          <Avatar
            sx={{
              bgcolor: '#4a6cf7',
              width: 36,
              height: 36,
              fontSize: '14px',
              fontWeight: 600,
            }}
          >
            {getUserInitials()}
          </Avatar>
          {!isMobile && (
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: 600, 
                color: '#1a1a2e',
                fontSize: '0.95rem',
              }}
            >
              {getFullName()}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Topbar;
